var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.98529 6.2925C3.85232 6.68117 3.78473 7.08921 3.78529 7.5C3.78529 7.95875 3.86779 8.39813 4.02029 8.80375C4.21035 9.31073 4.50891 9.77006 4.89506 10.1496C5.28121 10.5291 5.74563 10.8197 6.25582 11.001C6.76601 11.1822 7.30965 11.2498 7.8487 11.199C8.38775 11.1482 8.90919 10.9803 9.37654 10.7069H9.37716C10.1134 10.2752 10.6791 9.60382 10.9797 8.805H7.63779V6.3325H13.6409C13.7962 7.1503 13.7868 7.99085 13.6134 8.805C13.3129 10.2124 12.5358 11.473 11.4134 12.3737C10.3048 13.2665 8.92366 13.7522 7.50029 13.75C6.42714 13.7506 5.37193 13.4748 4.43631 12.9492C3.50069 12.4236 2.7162 11.6659 2.15842 10.7491C1.60064 9.83231 1.28837 8.78731 1.2517 7.71479C1.21502 6.64227 1.45518 5.57838 1.94904 4.62562C2.47589 3.60807 3.2724 2.75498 4.25146 2.15963C5.23052 1.56428 6.35443 1.2496 7.50029 1.25C9.01654 1.25 10.4072 1.79 11.4897 2.68875L9.46466 4.34625C8.9903 4.05102 8.45549 3.86652 7.89999 3.80646C7.3445 3.7464 6.78261 3.81233 6.2561 3.99934C5.7296 4.18635 5.25202 4.48964 4.85888 4.88665C4.46573 5.28366 4.16713 5.76419 3.98529 6.2925Z",
    fill: "#8A7C8D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/googleIcon.379aeef206e02bd2f4fa37eb7f51cca6.svg";
export { ForwardRef as ReactComponent };